import debug from 'debug';
import SearchApi from "Global/Minetilbud/Shared/Components/api-management/search";

const log = debug('SearchBox:Data:AutoSuggest');

class AutoSuggest {
	abort() {
		if (this.controller) {
			this.controller.abort();
		}
	}

	/**
	 * @returns {Promise}
	 */
	async get(term) {
		try {
			const searchApi = new SearchApi();
			this.controller = new AbortController();

			const signal = this.controller.signal;
			const dataset = await searchApi.getAutoSuggest(term, signal);
			return dataset;
		} catch(error) {
			log('get() - error', error);
		}
	}
}

export default AutoSuggest;
